var vars = require('./core');

module.exports = vars.createClass('PolarArea', ['getSegmentsAtEvent']);



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs/lib/polar-area.js
// module id = 1052
// module chunks = 0